<div class="card mb-0 metric-card-style">
  <div class="card-body metric-card-body">
    <div class="metric-card-header">
      <div class="metric-card-title-row">
        <div class="metric-card-title-group">
          <h5 class="card-title mb-0 metric-card-title">{{ metric().title }}</h5>
          @if (metric().status_label) {
            <span class="metric-status-badge" [class]="status_badge_class()">{{ metric().status_label }}</span>
          }
        </div>
        <div class="metric-card-header-actions">
          @if (metric().simple_type_suffix_type === 'icon' || metric().simple_type_suffix_type === 'google_icon') {
            <mat-icon class="metric-header-icon material-icons-outlined">{{ metric().simple_type_suffix_icon_google_name }}</mat-icon>
          }
          <button
            mat-icon-button
            type="button"
            class="small-icon-button"
            [matMenuTriggerFor]="metric_menu"
            aria-label="Acciones de la métrica"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #metric_menu="matMenu">
            @if (can_edit_thresholds()) {
              <button mat-menu-item type="button" (click)="openVariableConditionDialog()">
                <mat-icon>tune</mat-icon>
                <span>Modificar parámetros</span>
              </button>
            }
            <button mat-menu-item type="button" (click)="openIngestHelp()">
              <mat-icon>code</mat-icon>
              <span>Enviar datos</span>
            </button>
          </mat-menu>
        </div>
      </div>

      <div class="d-flex align-items-end justify-content-between">
        <div>
          <div class="d-flex align-items-baseline">
            <h2 class="mb-0 fw-bold metric-value" [class]="value_color_class()">
              {{ metric().simple_type_value }}
            </h2>
            @if (metric().simple_type_value_units) {
              <span class="ms-1 text-muted metric-value-unit">{{ metric().simple_type_value_units }}</span>
            }
          </div>

          @if (show_month_trend()) {
            <div class="mt-1 d-flex align-items-center metric-incremental">
              <span [class]="month_trend_color_class()" class="fw-bold d-flex align-items-center">
                <mat-icon class="incremental-arrow">{{ month_trend_arrow() }}</mat-icon>
                {{ metric().month_trend_percent! > 0 ? '+' : '' }}{{ metric().month_trend_percent | number: '1.0-1' }}%
              </span>
              <span class="text-muted ms-1">vs. últimos 30 días</span>
            </div>
          } @else if (metric().simple_type_incremental_prcnt || metric().simple_type_incremental_value) {
            @let incremental = incremental_value_number();
            <div class="mt-1 d-flex align-items-center metric-incremental">
              <span [class]="incremental_color_class()" class="fw-bold d-flex align-items-center">
                @if (incremental != null && incremental > 0) {
                  <mat-icon class="incremental-arrow">arrow_upward</mat-icon>
                } @else if (incremental != null && incremental < 0) {
                  <mat-icon class="incremental-arrow">arrow_downward</mat-icon>
                }
                {{ metric().simple_type_incremental_prcnt ? metric().simple_type_incremental_prcnt : '' }}
                {{
                  metric().simple_type_incremental_value
                    ? (metric().simple_type_incremental_prcnt ? ' (' : '') +
                      metric().simple_type_incremental_value +
                      (metric().simple_type_incremental_prcnt ? ')' : '')
                    : ''
                }}
              </span>
              @if (metric().simple_type_footer_text) {
                <span class="text-muted ms-1">{{ metric().simple_type_footer_text }}</span>
              }
            </div>
          } @else if (metric().simple_type_footer_text) {
            <div class="mt-1 text-muted metric-footer">
              {{ metric().simple_type_footer_text }}
            </div>
          }
        </div>

        @if (
          metric().simple_type_suffix_type !== 'none' &&
          metric().simple_type_suffix_type !== 'icon' &&
          metric().simple_type_suffix_type !== 'google_icon'
        ) {
          <div class="suffix-container ms-3">
            @if (metric().simple_type_suffix_type === 'circular_progress') {
              <div class="circular-progress-wrap">
                <mat-progress-spinner
                  [class]="circular_progress_color_class()"
                  [mode]="'determinate'"
                  [value]="metric().simple_type_suffix_circular_progress_prcnt"
                  [diameter]="50"
                  [strokeWidth]="5"
                  class="circular-progress-spinner"
                >
                </mat-progress-spinner>
                <span class="small fw-bold">{{ metric().simple_type_suffix_circular_progress_prcnt }}</span>
              </div>
            }

            @if (metric().simple_type_suffix_type === 'svg_line' && metric().simple_type_suffix_svg_line_html) {
              <div [innerHTML]="sanitized_svg_line()"></div>
            }
          </div>
        }
      </div>

      @if (metric().simple_type_suffix_type === 'progress_bar') {
        <div class="mt-2">
          <mat-progress-bar
            mode="determinate"
            [value]="metric().simple_type_suffix_progress_bar_prcnt"
            [class]="progress_bar_color_class()"
            class="metric-progress-bar"
          >
          </mat-progress-bar>
        </div>
      }
    </div>

    <hr class="metric-card-divider" />

    <div class="metric-visualization-block">
      @if (active_chart(); as chart) {
        <div class="metric-visualization-carousel" [class.has-carousel]="has_carousel()">
          @if (has_carousel()) {
            <button
              mat-icon-button
              type="button"
              class="carousel-arrow carousel-arrow-prev"
              aria-label="Visualización anterior"
              (click)="showPreviousVisualization()"
            >
              <mat-icon>chevron_left</mat-icon>
            </button>
            <button
              mat-icon-button
              type="button"
              class="carousel-arrow carousel-arrow-next"
              aria-label="Visualización siguiente"
              (click)="showNextVisualization()"
            >
              <mat-icon>chevron_right</mat-icon>
            </button>
          }

          <div class="chart-container">
            @for (_ of [active_visualization_index()]; track _) {
              <apx-chart
                [series]="$any(chart).series"
                [chart]="$any(chart).chart"
                [xaxis]="$any(chart).xaxis"
                [stroke]="$any(chart).stroke"
                [tooltip]="$any(chart).tooltip"
                [dataLabels]="$any(chart).dataLabels"
                [labels]="$any(chart).labels"
                [legend]="$any(chart).legend"
                [colors]="$any(chart).colors"
                [fill]="$any(chart).fill"
                [grid]="$any(chart).grid"
                [plotOptions]="$any(chart).plotOptions"
                [yaxis]="$any(chart).yaxis"
              ></apx-chart>
            }
          </div>
        </div>
      } @else {
        <div class="no-visualizations-warning" role="status">Sin visualizaciones</div>
      }
    </div>
  </div>
</div>
